
import { defineComponent } from "vue";
import CodeHighlighter from "@/components/highlighters/CodeHighlighter.vue";
import { code3 } from "@/views/resources/documentation/element-ui/basic/layout/code";

export default defineComponent({
  name: "hybrid-layout",
  components: {
    CodeHighlighter
  },
  setup() {
    return {
      code3
    };
  }
});
